import React, {CSSProperties, FunctionComponent} from "react";
import {Button} from "@material-ui/core";

type SvgButtonProps = {
    svg: string;
    onClick?: () => void;
    altText?: string;
    style?: CSSProperties;
    className?: string;
    size?: number;
    onMouseEnter?: () =>void;
    onMouseLeave?: () =>void;
};

const SvgButton: FunctionComponent<SvgButtonProps> = ({svg, altText, onClick, style, className, size, onMouseEnter, onMouseLeave}) => (
    <Button onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className={className} onClick={onClick} style={{minWidth: 0, padding: 0,  ...style}}>
        <img style={{zIndex: 100, width: size, height: size}} src={svg} alt={altText ? altText : ""}/>
    </Button>
);

export default SvgButton;
